<template>
  <div>
    <v-card tile flat v-if="fullscreen">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5 primary white--text">
            <h1 class="headline"> <strong>Info Dasar</strong> Kandidat</h1>
            <p> Berikut informasi dasar Kandidat yang akan melakukan wawancara </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-0 pa-2 mt-1" :elevation="fullscreen ? 1 : 0">
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" md="7">
            <v-toolbar flat dense>
              <v-toolbar-title> Data Kandidat </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <template>
              <v-row dense no-gutters>
                <v-col cols="12" md="3" class="text-center d-inline-flex align-center justify-center">
                  <template v-if="foto">
                    <v-img :src="$imgUrl(foto)" max-width="110" max-height="150" />
                  </template>
                  <template v-else>
                    <v-icon size="80" color="primary">mdi-account-circle</v-icon>
                  </template>
                </v-col>
                <v-col cols="12" md="9">
                  <v-list three-line class="px-2 m2-5">
                    <v-row dense no-gutters>
                      <v-col cols="12" md="6" class="pa-2">
                        <v-list-item-content class="pa-0">
                          <v-list-item-title class="body-2 grey--text my-n1">Nama</v-list-item-title>
                          <p class="body-2">
                            {{ $getDeepObj(detail, 'ptk.data.nama') || '-' }}
                          </p>
                        </v-list-item-content>
                      </v-col>
                      <v-col cols="12" md="6" class="pa-2">
                        <v-list-item-content class="pa-0">
                          <v-list-item-title class="body-2 grey--text my-n1">Instansi</v-list-item-title>
                          <p class="body-2">{{ instansi }}</p>
                        </v-list-item-content>
                      </v-col>
                      <v-col cols="12" md="6" class="pa-2">
                        <v-list-item-content class="pa-0">
                          <v-list-item-title class="body-2 grey--text my-n1">Asal Daerah</v-list-item-title>
                          <p class="body-2">{{ asal }}</p>
                        </v-list-item-content>
                      </v-col>
                      <v-col cols="12" md="6" class="pa-2" v-if="!isAsesor">
                        <v-list-item-content class="pa-0">
                          <v-list-item-title class="body-2 grey--text my-n1">No.Telp</v-list-item-title>
                          <p class="body-2">
                            {{ $getDeepObj(detail, 'no_wa') || $getDeepObj(detail, 'ptk.data.no_telp') || '-' }}
                            <template
                              v-if="
                                ($getDeepObj(detail, 'no_wa') || $getDeepObj(detail, 'ptk.data.no_telp')) && !isAsesor
                              "
                            >
                              <v-icon
                                color="success"
                                small
                                dark
                                @click="
                                  onCall(
                                    Number(
                                      $getDeepObj(detail, 'no_wa') || $getDeepObj(detail, 'ptk.data.no_telp') || ''
                                    )
                                  )
                                "
                              >
                                mdi-whatsapp
                              </v-icon>
                            </template>
                          </p>
                        </v-list-item-content>
                      </v-col>
                      <v-col cols="12" md="6" class="pa-2">
                        <v-list-item-content class="pa-0">
                          <v-list-item-title class="body-2 grey--text my-n1">Tanggal Lahir</v-list-item-title>
                          <p class="body-2">
                            {{ $localDate($getDeepObj(detail, 'ptk.data.tgl_lahir') || '') }}
                          </p>
                        </v-list-item-content>
                      </v-col>
                    </v-row>
                  </v-list>
                </v-col>
              </v-row>
            </template>

            <v-toolbar flat dense>
              <v-toolbar-title> Data Kontak Kerabat</v-toolbar-title>
            </v-toolbar>
            <v-divider class="my-2" />
            <v-row v-show="!isAsesor">
              <template v-for="(column, id) in pspKontaks">
                <v-col class="py-0" cols="12" :md="column.size" :key="id">
                  <v-list-item class="px-1 pb-0">
                    <v-list-item-content>
                      <div class="mb-0 grey--text label--text" style="line-height: 1rem">
                        {{ column.title }}
                      </div>
                      <div>
                        {{ column.value || '' }}
                        <v-icon
                          v-if="column.key === 'no_hp' && $getDeepObj(column, 'value')"
                          color="success"
                          small
                          dark
                          @click="onCall(Number($getDeepObj(column, 'value') || ''))"
                        >
                          mdi-whatsapp
                        </v-icon>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </template>
            </v-row>
          </v-col>
          <v-col cols="12" md="5" v-if="Object.keys(pspWawancara).length">
            <v-toolbar flat dense>
              <v-toolbar-title> Detil {{ title }} </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-list three-line class="px-2 m2-5">
              <v-row dense no-gutters>
                <template v-if="$getDeepObj(pspWawancara, 'akun_penilai.data')">
                  <v-col cols="12" class="pa-2">
                    <v-list-item-content class="pa-0">
                      <v-list-item-title class="body-2 blue--text">Asesor A</v-list-item-title>
                      <h4>{{ $getDeepObj(pspWawancara, 'akun_penilai.data.nama') || '-' }}</h4>
                      <div v-if="$getDeepObj(pspWawancara, 'akun_penilai.data.no_hp')">
                        {{ $getDeepObj(pspWawancara, 'akun_penilai.data.no_hp') || '-' }}
                        <v-icon
                          color="success"
                          small
                          dark
                          @click="onCall(Number($getDeepObj(pspWawancara, 'akun_penilai.data.no_hp') || ''))"
                        >
                          mdi-whatsapp
                        </v-icon>
                      </div>
                      <div v-else>
                        {{ $getDeepObj(pspWawancara, 'akun_penilai.data.no_telpon') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-col>
                </template>
                <template v-if="$getDeepObj(pspWawancara, 'akun_penjadwal.data.psp_pemantau_asesor_asesor.data')">
                  <v-col cols="12" class="pa-2">
                    <v-list-item-content class="pa-0">
                      <v-list-item-title class="body-2 blue--text">Tim Pemantau Asesor A</v-list-item-title>
                      <h4>{{
                        $getDeepObj(
                          pspWawancara,
                          'akun_penjadwal.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.nama'
                        ) || '-'
                      }}</h4>
                      <div
                        v-if="
                          $getDeepObj(
                            pspWawancara,
                            'akun_penjadwal.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                          )
                        "
                      >
                        {{
                          $getDeepObj(
                            pspWawancara,
                            'akun_penjadwal.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                          ) || '-'
                        }}
                        <v-icon
                          color="success"
                          small
                          dark
                          @click="
                            onCall(
                              Number(
                                $getDeepObj(
                                  pspWawancara,
                                  'akun_penjadwal.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                                ) || ''
                              )
                            )
                          "
                        >
                          mdi-whatsapp
                        </v-icon>
                      </div>
                      <div v-else>
                        {{
                          $getDeepObj(
                            pspWawancara,
                            'akun_penjadwal.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_telpon'
                          ) || '-'
                        }}
                      </div>
                    </v-list-item-content>
                  </v-col>
                </template>
                <template v-if="$getDeepObj(pspWawancara, 'akun_pendamping.data')">
                  <v-col cols="12" class="pa-2">
                    <v-list-item-content class="pa-0">
                      <v-list-item-title class="body-2 red--text">Asesor B</v-list-item-title>
                      <h4>{{ $getDeepObj(pspWawancara, 'akun_pendamping.data.nama') || '-' }}</h4>
                      <div v-if="$getDeepObj(pspWawancara, 'akun_pendamping.data.no_hp')">
                        {{ $getDeepObj(pspWawancara, 'akun_pendamping.data.no_hp') || '-' }}
                        <v-icon
                          color="success"
                          small
                          dark
                          @click="onCall(Number($getDeepObj(pspWawancara, 'akun_pendamping.data.no_hp') || ''))"
                        >
                          mdi-whatsapp
                        </v-icon>
                      </div>
                      <div v-else>
                        {{ $getDeepObj(pspWawancara, 'akun_pendamping.data.no_telpon') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-col>
                </template>
                <template v-if="$getDeepObj(pspWawancara, 'akun_pendamping.data.psp_pemantau_asesor_asesor.data')">
                  <v-col cols="12" class="pa-2">
                    <v-list-item-content class="pa-0">
                      <v-list-item-title class="body-2 red--text">Tim Pemantau Asesor B</v-list-item-title>
                      <h4>{{
                        $getDeepObj(
                          pspWawancara,
                          'akun_pendamping.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.nama'
                        ) || '-'
                      }}</h4>
                      <div
                        v-if="
                          $getDeepObj(
                            pspWawancara,
                            'akun_pendamping.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                          )
                        "
                      >
                        {{
                          '+62' +
                            Number(
                              $getDeepObj(
                                pspWawancara,
                                'akun_pendamping.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                              ) || '-'
                            )
                        }}
                        <v-icon
                          color="success"
                          small
                          dark
                          @click="
                            onCall(
                              Number(
                                $getDeepObj(
                                  pspWawancara,
                                  'akun_pendamping.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_hp'
                                ) || ''
                              )
                            )
                          "
                        >
                          mdi-whatsapp
                        </v-icon>
                      </div>
                      <div v-else>
                        {{
                          $getDeepObj(
                            pspWawancara,
                            'akun_pendamping.data.psp_pemantau_asesor_asesor.data.akun_pemantau.data.no_telpon'
                          ) || '-'
                        }}
                      </div>
                    </v-list-item-content>
                  </v-col>
                </template>
                <v-col cols="12" class="pa-2">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="body-2 grey--text">Tanggal {{ title }}</v-list-item-title>
                    <h4>{{ $localDate($getDeepObj(pspWawancara, 'tgl_simulasi') || '-') }}</h4>
                  </v-list-item-content>
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="body-2 grey--text">Jam Mulai</v-list-item-title>
                    <h4>{{ $localTime($getDeepObj(pspWawancara, 'jam_mulai'), { suffix: 'WIB' }) }}</h4>
                  </v-list-item-content>
                </v-col>
                <v-col cols="12" md="6" class="pa-2">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="body-2 grey--text">Jam Selesai</v-list-item-title>
                    <h4>{{ $localTime($getDeepObj(pspWawancara, 'jam_selesai'), { suffix: 'WIB' }) }}</h4>
                  </v-list-item-content>
                </v-col>
                <v-col cols="12" class="pa-2 px-0" v-if="isWawancara && useLink">
                  <v-card class="blue darken-3" max-width="300" flat @click="onMeet" style="cursor: pointer">
                    <v-list dense class="blue darken-3" dark>
                      <v-list-item two-line>
                        <v-list-item-avatar>
                          <v-icon x-large>mdi-google-hangouts</v-icon>
                        </v-list-item-avatar>
                        <div>
                          <v-list-item-subtitle>Tautan google meet</v-list-item-subtitle>
                          <h2>Mulai Wawancara</h2>
                        </div>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
                <v-col cols="12" class="py-2 ml-2 grey--text" v-if="isWawancara && useLink">
                  Pastikan Anda bersiap 15-30 menit sebelum sesi jadwal wawancara dengan Kandidat.
                </v-col>
                <v-col cols="12" class="py-2 ml-2 grey--text" v-if="isWawancara && useLink">
                  Informasi Kandidat bisa dilihat disamping kiri sebagai Referensi saat Wawancara.
                </v-col>
              </v-row>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <popup-preview-detail ref="view" :url="foto_ktp || ''" title="Detail Foto KTP" />
  </div>
</template>
<script>
import PopupPreviewDetail from '@components/popup/PreviewDetil';
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'pendukung',
    },
    fullscreen: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Wawancara',
    },
    useLink: {
      type: Boolean,
      default: true,
    },
    isAsesor: {
      type: Boolean,
      default: true,
    },
  },
  components: { PopupPreviewDetail },
  data() {
    return {
      imgFoto: null,
      imgFotoKtp: null,
    };
  },
  computed: {
    pspWawancara() {
      return this.$getDeepObj(this, 'detail.psp_simulasi') || {};
    },

    isWawancara() {
      return Number(this.$getDeepObj(this, 'pspWawancara.tahap')) === 1;
    },

    profesi() {
      return '';
    },

    instansi() {
      return this.$getDeepObj(this, 'detail.sekolah.data.nama') || '-';
    },

    asal() {
      return this.$getDeepObj(this, 'detail.m_kota.data.keterangan');
    },

    surel() {
      return this.$getDeepObj(this, 'detail.ptk.data.email') || '-';
    },

    noUkg() {
      return this.$getDeepObj(this, 'detail.ptk.data.no_ukg') || '-';
    },

    foto() {
      return this.imgFoto;
    },

    foto_ktp() {
      return this.imgFotoKtp;
    },

    type_ktp() {
      let ktp = this.imgFotoKtp ? this.imgFotoKtp.split('.') : '';
      return ktp ? ktp.pop() : null;
    },

    pspKontaks() {
      const data = this.$getDeepObj(this.detail, 'psp_profil_kontaks.data') || [];
      let temp = [];
      data.forEach((item) => {
        temp.push(
          {
            key: 'nama',
            title: 'Nama',
            value: this.$getDeepObj(item, 'nama') || '',
            size: 4,
          },
          {
            key: 'hubungan',
            title: 'Hubungan dengan pemilik kontak',
            value: this.$getDeepObj(item, 'm_profil_opsi_psp_keluarga.data.keterangan') || '',
            size: 4,
          },
          {
            key: 'no_hp',
            title: 'No.Telepon',
            value: this.$getDeepObj(item, 'no_telp') || '',
            size: 4,
            hidden: this.isAsesor,
          }
        );
      });

      return temp;
    },
  },
  methods: {
    reset() {
      this.$set(this, 'imgFoto', null);
      this.$set(this, 'imgFotoKtp', null);
    },

    onMeet() {
      window.open(this.$getDeepObj(this, 'meta.url_meet'), '_blank');
    },

    checkImage(imgSrc, type) {
      let img = new Image();

      img.onload = () => {
        this[type] = imgSrc;
      };
      img.src = imgSrc;
    },

    render(value) {
      this.checkImage(this.$getDeepObj(value, 'ptk.data.foto'), 'imgFoto');
      this.checkImage(this.$getDeepObj(value, 'foto_ktp'), 'imgFotoKtp');
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(item)}`;
      window.open(url, '_blank');
    },
  },

  watch: {
    detail: 'render',
  },
};
</script>
